import React from 'react'

import { Icon, IconTypes, useFormatMessage } from '@acre/design-system'

import type { FooterVariant } from './Footer.types'
import { GreyText, StyledDiv, StyledIcon } from './Footer.styles'

type FooterProps = {
  variant?: FooterVariant
}

const Footer = ({ variant = 'default' }: FooterProps) => {
  const formatMessage = useFormatMessage()

  return (
    <StyledDiv>
      <GreyText variant={variant}>{formatMessage('dashboard.footer')}</GreyText>
      <StyledIcon>
        <Icon name={variant === 'light' ? IconTypes.AcreWordMarkLight : IconTypes.AcreWordMark} />
      </StyledIcon>
    </StyledDiv>
  )
}

export default Footer
